import React from 'react';
import { EMPTY_STAR, FULL_STAR, HALF_STAR, QUARTER_STAR, STAR_FILL_MAP, THREE_QUARTER_STAR } from './Ratings.constants';
import { StarGradientContainer } from './Ratings.styles';
const STAR_GRADIENT_CONFIG = [{
  id: QUARTER_STAR,
  offset: '25%'
}, {
  id: HALF_STAR,
  offset: '50%'
}, {
  id: THREE_QUARTER_STAR,
  offset: '75%'
}];
export const StarGradients = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, STAR_GRADIENT_CONFIG.map((_ref, index) => {
    let {
      id,
      offset
    } = _ref;
    return /*#__PURE__*/React.createElement(StarGradientContainer, {
      key: index
    }, /*#__PURE__*/React.createElement("linearGradient", {
      id: id
    }, /*#__PURE__*/React.createElement("stop", {
      offset: offset,
      stopColor: STAR_FILL_MAP[FULL_STAR].fill
    }), /*#__PURE__*/React.createElement("stop", {
      offset: offset,
      stopColor: STAR_FILL_MAP[EMPTY_STAR].fill
    })));
  }));
};